import {createAction} from '@reduxjs/toolkit';
import { Contact } from '../../shared/interfaces';

export const setContacts = createAction<Contact[]>('setContacts');
export const setSubscribed = createAction<Contact[]>('setSubscribed');
export const resetAgenda = createAction('resetContacts');
export const collapseAll = createAction('collapseAll')